import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';
import sKey from '../../SoundAssetKeys';
import { simpleClickAnimation } from './makeDonutStart';
import { summonSprinkles } from './sprinkleLayouts';

export function createChooseSprinkle(scene)
{
    if(scene.sprinkleCont.list.length === 0)gameData.makeData.sprinkle = false;
    if(!gameData.makeData.sprinkleUI)
    {
        centerSprinkleDonut(scene)
        return sprinkleTween();
        
    }
    else
    {
        return sprinkleTween
    }
}

export function cleanUpSprinkle(scene)
{
    for(let each in gameData.makeData.sprinkleUI)
    {
        gameData.makeData.sprinkleUI[each].destroy();
    }

    gameData.makeData.sprinkleUI = "";
}

export function cleanUpPlacedSprinkles(scene)
{
    let tween;
    scene.custSound.playSoundCustom(sKey._sprinkle_fall);
    for(let each in scene.sprinkleCont.list)
    {
        tween = ABCya.Tweens.addTween(scene.sprinkleCont.list[each],400,{y:"+=800",alpha:0,delay:5*each},Phaser.Math.Easing.Quadratic.InOut);
    
        if(Number(each) === length)
        {
            tween.on('complete',()=>{
                scene.sprinkleCont.removeAll(true);
            });
        }
    }
}

export function centerSprinkleDonut(scene)
{
    const donut = scene.makeDonut;

    const sprinkleButtons = createButtons(donut);

    gameData.makeData.sprinkleUI = sprinkleButtons;

    for(let each in sprinkleButtons)
    {
        sprinkleButtons[each].on("pointerdown",()=>{
            sprinkleButtonOnclick(sprinkleButtons[each]);
        })
    }
}

function sprinkleButtonOnclick(gameObject)
{
    const scene = gameObject.scene;
    const split = gameObject.frame.name.split("_");
    let type = split[split.length-1];
    type = type.substr(0,type.length-1);

    gameData.makeData.sprinkle = true;
    
    simpleClickAnimation(gameObject,true,false);

    let tween;

    for(let each in gameData.makeData.sprinkleUI)
    {
        gameData.makeData.sprinkleUI[each].disableInteractive();
    }

    if(scene.sprinkleCont.count() === 0)
    {
        dropSprinkles(scene);
    }
    else
    {
        const length = (scene.sprinkleCont.list.length - 1);
        const sprinkLength = scene.sprinkleCont.list.length/2;
        for(let each = 0; each < sprinkLength; each++)
        {
            tween = ABCya.Tweens.addTween(scene.sprinkleCont.list[each*2],100,{y:"+=200",alpha:0,delay:5*each},Phaser.Math.Easing.Quadratic.InOut);
            ABCya.Tweens.addTween(scene.sprinkleCont.list[(each*2)+1],100,{y:"+=200",alpha:0,delay:5*each},Phaser.Math.Easing.Quadratic.InOut);
        
            if(each === sprinkLength-1)
            {
                tween.on('complete',()=>{
                    scene.sprinkleCont.removeAll(true);
                    dropSprinkles();
                });
            }
        }
    }

    function dropSprinkles()
    {
        scene.sprinkleCont.add(summonSprinkles(scene,scene.makeDonut,type));
        scene.custSound.playSoundCustom(sKey._sprinkle_fall);
        const sprinkLength = scene.sprinkleCont.list.length/2;
        for(let each = 0; each < sprinkLength; each++)
        {
            tween = ABCya.Tweens.addTween(scene.sprinkleCont.list[each*2],900,{y:{start:scene.sprinkleCont.list[each*2].y-300,to:scene.sprinkleCont.list[each*2].y},alpha:1,delay:5*each},Phaser.Math.Easing.Quadratic.InOut);
            ABCya.Tweens.addTween(scene.sprinkleCont.list[(each*2)+1],900,{y:{start:scene.sprinkleCont.list[(each*2)+1].y-300,to:scene.sprinkleCont.list[(each*2)+1].y},alpha:.75,delay:5*each},Phaser.Math.Easing.Quadratic.InOut,()=>
            {
                if(each === sprinkLength-1)
                {
                    for(let eachin in gameData.makeData.sprinkleUI)
                    {
                        gameData.makeData.sprinkleUI[eachin].setInteractive();
                    }
                }
            });
        }
    }
}

function createButtons(gameObject)
{
    const scene = gameObject.scene;
    const dist = 60;
    const returnArray = [];
    
    const squareCheck = (gameObject.frame.name.includes("Square")) ? 15 : 0;

    let objRadius = (gameObject.width * gameObject.scale)*.5 + dist + squareCheck;
    let extraDist = 0;
    if(gameObject.frame.name.includes("Triangle"))
    {
        extraDist = 20;
    }
    else if(gameObject.frame.name.includes("Heart"))
    {
        extraDist = -12;
    }
    else if(gameObject.frame.name.includes("Star"))
    {
        extraDist = 10;
        objRadius -= 5;
    }
    const cornerDist = objRadius / Math.sqrt(2);//formula for isoceles right triangle

    returnArray.push(ABCya.Images.addImage(gameObject.x - cornerDist,gameObject.y - cornerDist + extraDist,"Make Your Donut/Btn_Jimmys",scene).setDepth(4).setAlpha(0));
    returnArray.push(ABCya.Images.addImage(gameObject.x + cornerDist,gameObject.y - cornerDist + extraDist,"Make Your Donut/Btn_Dots",scene).setDepth(4).setAlpha(0));
    returnArray.push(ABCya.Images.addImage(gameObject.x - cornerDist,gameObject.y + cornerDist + extraDist,"Make Your Donut/Btn_Stars",scene).setDepth(4).setAlpha(0));
    returnArray.push(ABCya.Images.addImage(gameObject.x + cornerDist,gameObject.y + cornerDist + extraDist,"Make Your Donut/Btn_Hearts",scene).setDepth(4).setAlpha(0));

    return returnArray;
}

function sprinkleTween()
{
    return new Promise(resolve => {
        const arr = gameData.makeData.sprinkleUI;
        const time = 500;

        const scene = gameData.makeData.sprinkleUI[0].scene;
        scene.custSound.playSoundCustom(sKey._title_donut_enter);

        ABCya.Tweens.addTween(arr[0], time, {x:{start:0,to:arr[0].x},y:{start:0,to:arr[0].y},alpha:1},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[1], time, {x:{start:1068,to:arr[1].x},y:{start:0,to:arr[1].y},alpha:1},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[2], time, {x:{start:0,to:arr[2].x},y:{start:768,to:arr[2].y},alpha:1},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[3], time, {x:{start:1068,to:arr[3].x},y:{start:768,to:arr[3].y},alpha:1},Phaser.Math.Easing.Quadratic.Out,()=>{
            for(let each in arr)
            {
                arr[each].setInteractive();
            }
            resolve();
        });
    });

}

export function sprinkleTweenOut()
{
    return new Promise(resolve =>{
        const arr = gameData.makeData.sprinkleUI;
        const time = 500;
        const scene = gameData.makeData.sprinkleUI[0].scene;
        scene.custSound.playSoundCustom(sKey._title_donut_leave);

        ABCya.Tweens.addTween(arr[0], time, {x:0,y:0,yoyo:true},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[1], time, {x:1068,y:0,yoyo:true},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[2], time, {x:0,y:768,yoyo:true},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[3], time, {x:1068,y:768,yoyo:true},Phaser.Math.Easing.Quadratic.Out);
    
        ABCya.Tweens.addTween(arr[0], time, {alpha:0},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[1], time, {alpha:0},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[2], time, {alpha:0},Phaser.Math.Easing.Quadratic.Out);
        ABCya.Tweens.addTween(arr[3], time, {alpha:0},Phaser.Math.Easing.Quadratic.Out,()=>{
            resolve();
        });
    })
}
